

<full-calendar [options]="calendarOptions" style=" padding: 40px; "></full-calendar>